import { connect } from 'react-redux'
import { selectIsForwarding, selectIsAddingNote } from 'selectors/page'
import { doRemoveDraftRecipients } from 'ducks/drafts'
import RecipientsEditor from './view'

const perform = {
  doRemoveDraftRecipients,
}

const selectFactory = (initialState, initialOwnProps) => {
  const { type } = initialOwnProps
  return state => {
    return {
      allowMultipleRecipients: type !== 'to' || selectIsForwarding(state),
      forNote: selectIsAddingNote(state),
    }
  }
}

export default connect(selectFactory, perform)(RecipientsEditor)
